import { render, staticRenderFns } from "./CampaignMail.vue?vue&type=template&id=24f44b10&"
import script from "./CampaignMail.vue?vue&type=script&lang=js&"
export * from "./CampaignMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports